import Input from "./Input";

export default class InputHidden extends Input {

    constructor(element, form) {
        super(element, form);

        this.inputElement = this.element;
        this.name = this.inputElement.name;
        this._value = this.inputElement.value;
    }
}
